import React, { useEffect } from 'react'
import ThemeContextProvider from 'contexts/themeContext/ThemeContextProvider'
import { ScriptsDinamicGatsby } from 'component/ScriptsDinamicGatsby'
import { setSessionsAndCookies } from 'component/Helpers/setSessionsAndCookies'
import { Footer } from './footer'
import { Header } from './header'

import './layout.scss'

const Layout = ({ page, theme, topbar = false, ...props }) => {
	useEffect(() => {
		setSessionsAndCookies()
	}, [])

	return (
		<ThemeContextProvider value={theme} page={page}>
			<Header headerClass={props.headerClass} showTopbar={topbar} />
			{props.children}
			<Footer footerClass={props.footerClass} />
			<ScriptsDinamicGatsby />
		</ThemeContextProvider>
	)
}

export default Layout
